import { Carrier, Header } from "./types";

export function isCarrierSelected(carrier: Carrier): boolean {
  return carrier.sortOrder !== null;
}

export function getHeaders(showIndex: boolean): Header[] {
  const headers: Header[] = [
    {
      id: "name",
      label: "Name",
      isSortable: true,
    },
  ];
  if (showIndex) {
    headers.unshift({
      id: "index",
      label: "#",
      isSortable: true,
    });
  }

  return headers;
}
